import { render, staticRenderFns } from "./FileSearchPreview.vue?vue&type=template&id=1863707b"
import script from "./FileSearchPreview.vue?vue&type=script&lang=js"
export * from "./FileSearchPreview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports